// @flow
// Copied and adapted from packages/author-ui/src/context/AssignmentContext.tsx

import { createContext, useContext } from "react";
import type { Schema } from "../types/Schema";

type Context = {
  schemas: Schema[];
  schemaId: number;
  updateSchemas: () => Promise<void>;
  createSchema: (data: Object) => Promise<number>;
  deleteSchema: (id: number) => void;
  updateSchema: (id: number, schema: {}) => void;
};

const defaultState: Context = {
  schemas: [],
  schemaId: -1,
  updateSchemas: () => {
    console.warn("SchemaContext: not in scope.");
    return new Promise((resolve, _reject: any) => {
      resolve();
    });
  },
  createSchema: (_data: any) =>
    new Promise((resolve, _reject: any) => {
      resolve(-1);
    }),
  deleteSchema: () => console.warn("SchemaContext: not in scope."),
  updateSchema: () => console.warn("SchemaContext: not in scope."),
};

export const SchemaContext = createContext<Context>(defaultState);

export const useSchemaContext = () => useContext(SchemaContext);
